<!--
 * @Author: wh
 * @Date: 2020-07-02 10:09:52
 * @LastEditTime: 2022-12-07 15:42:09
 * @LastEditors: 任赛赛 5595670+ren_sai_sai_sai@user.noreply.gitee.com
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\retailAccount\newRetailAccount.vue
-->
<template>
    <div class="commonFormStyles newRetailAccount">
        <van-nav-bar
            title="新建"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <section class="van-pull-refresh showFontBtn">
            <van-form validate-first>
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>工程信息
                        </div>
                        <van-field
                            label="业务编号"
                            :left-icon="require('@/assets/images/icons/icon_gy_1.png')"
                            placeholder=""
                            v-model="formData.contract_number"
                            readonly
                        ></van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                            label="登记时间"
                            placeholder="请选择"
                            is-link
                            readonly
                            clickable
                            v-model="formData.register_time"
                            class="star"
                            @click="handleShowCalendar('register_time')"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_2.png')"
                            label="工程名称"
                            placeholder="请输入工程名称"
                            v-model="formData.engineering_name"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_gy_3.png')"
                            label="工程类型"
                            placeholder="请选择"
                            readonly
                            clickable
                            name="picker"
                            is-link
                            @click="showPopup('engineering_type')"
                            v-model="formData.engineering_type_name"
                            class="star"
                        >
                        </van-field>

                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_2.png')"
                            label="标段"
                            placeholder="请输入标段"
                            v-model="formData.section"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_gy_2.png')"
                            label="工程地址"
                            placeholder="请选择"
                            readonly
                            clickable
                            is-link
                            name="picker"
                            @click="toAddress"
                            v-model="formData.engineering_location"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_gy_3.png')"
                            label="供方单位"
                            placeholder="请选择"
                            readonly
                            class="star"
                            clickable
                            is-link
                            v-model="formData.org_name"
                            @click="showSelectOrg"
                        >
                        </van-field>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <div slot="title" class="title">
                            <i class="iconfont iconlianxiren"></i>联系人信息
                        </div>
                        <van-field
                            class="star customerName"
                            label="客户名称"
                            placeholder="请输入客户名称"
                            :left-icon="require('@/assets/images/icons/icon_3.png')"
                            v-model="formData.client_name"
                        >
                            <template #button v-if="(formData.client_name || '') !== ''">
                                <van-button size="mini" type="info" @click="customerNameInput">
                                    <van-icon name="friends-o" size="20"></van-icon>
                                </van-button>
                            </template>
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_gy_3.png')"
                            label="客户类型"
                            placeholder="请选择"
                            readonly
                            clickable
                            name="picker"
                            is-link
                            v-model="formData.client_type_name"
                            @click="showPopup('client_type')"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            class="star"
                            :left-icon="require('@/assets/images/icons/icon_33.png')"
                            label="统一社会信用代码"
                            placeholder="请输入统一社会信用代码"
                            v-model="formData.client_uscc"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_3.png')"
                            label="客户联系人"
                            placeholder="请输入客户联系人"
                            v-model="formData.client_contact_name"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_4.png')"
                            label="联系电话"
                            placeholder="请输入客户联系电话"
                            v-model="formData.client_contact_phone"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_3.png')"
                            label="业务员"
                            placeholder="请选择"
                            v-model="formData.salesman_name"
                            readonly
                            clickable
                            @click="selectSalesMan"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_4.png')"
                            label="业务员电话"
                            placeholder="请选择"
                            v-model="formData.salesman_phone"
                            readonly
                            clickable
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_3.png')"
                            label="供货站点"
                            placeholder="请选择"
                            readonly
                            clickable
                            is-link
                            v-model="formData.supply_site_name"
                            @click="showPopup('supply_site')"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_21.png')"
                            label="销售区域"
                            placeholder="请选择"
                            readonly
                            clickable
                            is-link
                            v-model="formData.area_name"
                            @click="showPopup('area_name')"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_6.png')"
                            label="方量（m³）"
                            placeholder="请输入方量"
                            v-model="formData.projected_capacity"
                            type="number"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_26.png')"
                            label="单价（元）"
                            placeholder="请输入单价"
                            v-model="formData.price"
                            type="number"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_26.png')"
                            label="金额（元）"
                            placeholder="请输入金额"
                            v-model="formData.amount_money"
                            type="number"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_20.png')"
                            label="支付方式"
                            placeholder="请选择"
                            readonly
                            clickable
                            is-link
                            @click="showPopup('payment_mode')"
                            v-model="formData.payment_mode_name"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_37.png')"
                            label="是否到账"
                        >
                            <template #input>
                                <van-switch v-model="formData.is_payment" size="20px"></van-switch>
                            </template>
                        </van-field>
                    </van-collapse-item>
                    <van-collapse-item name="3">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>其他信息
                        </div>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_gy_3.png')"
                            label="强度等级"
                            placeholder="请选择"
                            readonly
                            clickable
                            v-model="formData.strength_grade_name"
                            is-link
                            @click="showPopup('strength_grade')"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_6.png')"
                            label="附加型号"
                            placeholder="请选择"
                            readonly
                            clickable
                            v-model="formData.additional_model_name"
                            is-link
                            @click="showRequireList()"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_gy_2.png')"
                            label="浇筑部位"
                            placeholder="请选择"
                            readonly
                            clickable
                            v-model="formData.casting_parts_name"
                            is-link
                            @click="showPopup('casting_parts')"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_32.png')"
                            label="浇筑方式"
                            placeholder="请选择"
                            readonly
                            clickable
                            v-model="formData.pouring_way_name"
                            is-link
                            @click="showPopup('pouring_way')"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_32.png')"
                            label="泵车类型"
                            placeholder="请选择"
                            readonly
                            clickable
                            v-if="pumpTruckTypeDisable"
                            v-model="formData.pump_truck_name"
                            is-link
                            @click="showPopup('pump_truck')"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_26.png')"
                            label="泵送单价"
                            class="custom-field"
                            :disabled="volumePriceDisable"
                        >
                            <template #input>
                                <input
                                    placeholder="请输入"
                                    v-model="formData.pump_supplement_price"
                                    type="text"
                                >
                                <span>
                                    元/m³
                                </span>
                            </template>
                        </van-field>
                        <van-field
                            label="泵送补充模式"
                            class="trans-types"
                        >
                            <template #input>
                                <div>
                                    <van-radio-group
                                        v-model="formData.pump_complementary_model"
                                        direction="horizontal"
                                        :disabled="volumePriceDisable"
                                    >
                                        <van-radio :name="1" icon-size="16px">
                                            补方
                                        </van-radio>
                                        <van-radio :name="2" icon-size="16px">
                                            补固定金额
                                        </van-radio>
                                    </van-radio-group>
                                </div>
                                <div class="custom-row" v-if="formData.pump_complementary_model===1">
                                    <span>不足</span>
                                    <input
                                        v-model="formData.pump_insufficient"
                                        type="number"
                                        :disabled="volumePriceDisable"
                                    >
                                    <span>按</span>
                                    <input
                                        v-model="formData.pump_add_quantity"
                                        type="number"
                                        :disabled="volumePriceDisable"
                                    >
                                    方计算。
                                </div>
                                <div class="custom-row" v-if="formData.pump_complementary_model===2">
                                    <span>不足</span>
                                    <input
                                        v-model="formData.pump_insufficient"
                                        type="number"
                                        :disabled="volumePriceDisable"
                                    >
                                    <span>收取</span>
                                    <input
                                        v-model="formData.pump_add_money"
                                        type="number"
                                        :disabled="volumePriceDisable"
                                    >
                                    元。
                                </div>
                            </template>
                        </van-field>
                        <van-field
                            rows="2"
                            autosize
                            label="施工部位描述"
                            type="textarea"
                            maxlength="80"
                            class="iconfont textarea-parts star"
                            placeholder="施工部位描述"
                            v-model="formData.casting_parts_desc"
                        ></van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_16.png')"
                            label="塌落度"
                            class="star"
                        >
                            <div slot="input">
                                <input
                                    type="text"
                                    class="slump"
                                    v-model="formData.slumps"
                                    placeholder="请输入"
                                    @focusout="inputFocusout"
                                >
                                ±
                                <input
                                    type="text"
                                    v-model="formData.slumps_float"
                                    class="slump"
                                    placeholder="请输入"
                                    @focusout="inputFocusout"
                                >
                            </div>
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                            label="用料时间"
                            placeholder="请选择"
                            is-link
                            readonly
                            clickable
                            v-model="formData.used_materials_time"
                            @click="handleShowCalendar('used_materials_time')"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_11.png')"
                            label="运距（km）"
                            placeholder="请输入运距"
                            v-model="formData.haul_distance"
                            type="number"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_26.png')"
                            label="运费"
                            placeholder="请输入运费"
                            v-model="formData.freight"
                            type="number"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_26.png')"
                            label="基础运费"
                            class="custom-field star"
                        >
                            <template #input>
                                <input placeholder="请输入" v-model="formData.freight_supplement_price" type="text">
                                <span>元/m³</span>
                            </template>
                        </van-field>
                        <van-field
                            label="运费补充模式"
                            class="trans-types"
                        >
                            <template #input>
                                <div>
                                    <van-radio-group
                                        v-model="formData.freight_complementary_model"
                                        direction="horizontal"
                                    >
                                        <van-radio :name="1" icon-size="16px">
                                            补方
                                        </van-radio>
                                        <van-radio :name="2" icon-size="16px">
                                            补固定金额
                                        </van-radio>
                                    </van-radio-group>
                                </div>
                                <div class="custom-row" v-if="formData.freight_complementary_model===1">
                                    <span>每车不足</span>
                                    <input
                                        v-model="formData.freight_insufficient"
                                        type="number"
                                    >
                                    <span>方，按</span>
                                    <input
                                        v-model="formData.freight_add_quantity"
                                        type="number"
                                    >
                                    方收取费用。
                                </div>
                                <div class="custom-row" v-if="formData.freight_complementary_model===2">
                                    <span>单次方不足</span>
                                    <input
                                        v-model="formData.freight_insufficient"
                                        type="number"
                                    >
                                    <span>方，按实际方量价格结算后加收</span>
                                    <input
                                        v-model="formData.freight_add_money"
                                        type="number"
                                    >
                                    元。
                                </div>
                            </template>
                        </van-field>
                        <van-field
                            label="润泵砂浆价格"
                            class="trans-types"
                        >
                            <template #input>
                                <div>
                                    <van-radio-group
                                        v-model="formData.mortar_price_type"
                                        direction="horizontal"
                                    >
                                        <van-radio :name="0" icon-size="16px">
                                            与产品同价
                                        </van-radio>
                                        <van-radio :name="1" icon-size="16px">
                                            与产品不同价
                                        </van-radio>
                                    </van-radio-group>
                                </div>
                                <div class="custom-row" v-if="formData.mortar_price_type===1">
                                    <span>单次方不足</span>
                                    <input
                                        v-model="formData.mortar_price_percent"
                                        type="number"
                                    >
                                    <span>%产品价</span>
                                    <input
                                        v-model="formData.mortar_price"
                                        type="number"
                                    >
                                    元/方
                                </div>
                            </template>
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_24.png')"
                            label="附件"
                            placeholder="附件管理"
                            readonly
                            clickable
                            is-link
                            @click="toUpload"
                        >
                        </van-field>
                        <van-field
                            rows="2"
                            autosize
                            type="textarea"
                            maxlength="80"
                            class="iconfont iconbeizhu textarea"
                            placeholder="请在此处输入备注信息"
                            v-model="formData.remarks"
                        ></van-field>
                    </van-collapse-item>
                </van-collapse>

                <select-org ref="selectOrg" @change="handleSelectOrg"></select-org>
            </van-form>
            <!-- 选择弹出 -->
            <van-action-sheet
                v-model="showActionSheet"
                :actions="columns"
                @select="selectConfirm"
                :style="{height: '30%'}"
            ></van-action-sheet>
            <!-- 弹出日历控件 -->
            <van-popup
                v-model="showCalendar"
                position="bottom"
                :style="{ height: '50%' }"
            >
                <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    @confirm="confirmMonth"
                    @cancel="showCalendar=false"
                ></van-datetime-picker>
            </van-popup>
            <!-- 客户名称选择 -->
            <van-action-sheet
                v-model="showCustomerSelection"
                :actions="customerSelectionList"
                cancel-text="取消"
                close-on-click-action
                @select="handleSelect"
            ></van-action-sheet>
            <!-- 提交确认 -->
            <van-dialog
                v-model="confirmedByShow"
                title="提交确认"
                show-cancel-button
                @cancel="cancelSubmission"
                @confirm="confirmSubmission"
                class="submitPopUp"
            >
                <div class="submitPopUpContent">
                    <div class="icon">
                        <img src="@/assets/images/contractApproval/icon.png" alt="">
                    </div>
                    <div class="info linkInfo">
                        <h4>
                            下一环节：
                            <span>
                                {{ submitObj.link }}
                            </span>
                        </h4>
                        <h4>
                            审批人：
                            <span>
                                {{ submitObj.obj }}
                            </span>
                        </h4>
                        <p>是否确认提交？</p>
                    </div>
                </div>
            </van-dialog>
        </section>
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
        <footer class="commonFormBtns">
            <van-button type="info" @click="handleSubmit">
                提交
            </van-button>
            <van-button type="default" @click="handleSave(null)">
                保存
            </van-button>
        </footer>
    </div>
</template>

<script>
import { Toast } from 'vant';
import util from '@/assets/js/utils';
import selectOrg from './selectOrg';
export default {
    name: 'new-retail-account',
    components: { selectOrg },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/retailAccountList') {
            this.$store.commit('noKeepAlive', 'new-retail-account');
        }
        next();
    },
    props: {},
    data() {
        return {
            // 折叠面板-选中
            activeNames: ['1', '2', '3'],
            // 表单数据
            formData: {
            },
            // 日历
            showCalendar: false,
            calendarType: '',
            currentDate: new Date(),
            // 字典下拉选项
            showActionSheet: false,
            originalColumns: [],
            columns: [],
            actionType: '',
            // 工程类型
            engineeringTypeColumns: [],
            engineeringTypeOriginal: [],
            // 客户性质
            clientTypeOriginal: [],
            clientTypeColumns: [],
            // 支付方式
            payModeOriginal: [],
            payModeColumns: [],
            // 供货站点
            supplySiteOriginal: [],
            supplySiteColumns: [],
            // 销售区域
            saleAreaOriginal: [],
            saleAreaColumns: [],
            // 强度等级
            strengthGradeOriginal: [],
            strengthGradeColumns: [],
            // 浇筑部位
            castingPartsOriginal: [],
            castingPartsColumns: [],
            // 浇筑方式
            pouringWayOriginal: [],
            pouringWayColumns: [],
            // 泵车类型
            pouringTruckOriginal: [],
            pouringTruckColumns: [],
            // 流程信息
            businessInfo: {},
            // 操作 新增/修改
            type: '',
            // 表单主键
            formKeyValue: '',
            // 当前流程环节数据
            approvalData: {},
            processData: {},
            CurrentBusinessProcess: {},
            // 是否是消息跳转审批
            isNews: false,
            // 当前合同id
            contractNumber: '',
            // 展示加载层
            showOverlay: false,
            // 数字键盘
            showKeyboard: false,
            showPriceKeyboard: false,
            showCapacityKeyboard: false,
            showMoneyKeyboard: false,
            showFreightKeyboard: false,
            showDistanceKeyboard: false,
            keyboardValue: '',
            // 泵送单价是否可用
            volumePriceDisable: true,
            // 泵车类型是否可用
            pumpTruckTypeDisable: false,
            // 确认人员弹出层状态
            confirmedByShow: false,
            submitObj: {
                link: '',
                obj: '',
            },

            // 客户名称提示
            showCustomerSelection: false,
            // 客户集合
            customerSelectionList: [],
        };
    },
    watch: {},
    computed: {},
    created() {},
    activated() {
        this.getCategory('103', 'engineering_type');
        this.getCategory('002-xz0', 'client_type');
        this.getCategory('601-FK0', 'payment_mode');
        this.getCategory('105-ZT0', 'casting_parts');
        this.getCategory('302-JZ0', 'pouring_way');
        this.getCategory('303-BS0', 'pump_truck');
        this.getStationList();
        this.getSaleAreaList();
        this.getStrengthGrade();
        this.formData = this.$route.params.formData || this.formData;
        this.type = this.type || this.$route.params.handleType;
        const actionType = this.$route.params.actionType;
        if (actionType === 'selectedProjectAddressCallBack') {
            // 选择工程地址完成
            const lnglatXY = this.$route.params.lnglatXY;
            const address = this.$route.params.address;
            this.formData.engineering_location = address;
            this.formData.x_coordinate_point = `${lnglatXY[0]}`;
            this.formData.y_coordinate_point = `${lnglatXY[1]}`;
        }
        // 新建
        if (this.type === 'new' && actionType !== 'uploadFile'
        && actionType !== 'selectedProjectAddressCallBack' && actionType !== 'selededAdditional') {
            this.formData.register_time = util.currentTimeFormat('yyyy-MM-dd HH:mm:ss');
            this.getBusinessInstance();
            this.formData.salesman_id = this.$takeTokenParameters('Uid');
            this.formData.salesman_name = this.$takeTokenParameters('Name');
            this.formData.salesman_phone = this.$takeTokenParameters('MobilePhone');
        }
        // 编辑
        if (this.type === 'modify' && actionType !== 'selectedProjectAddressCallBack'
        && actionType !== 'selededAdditional' && actionType !== 'uploadFile') {
            this.showOverlay = true;
            this.contractNumber = this.contractNumber || this.$route.params.contractNumber;
            this.getRetailDetail(this.contractNumber);
        }
        // 复制新增
        if (this.type === 'copyNew' && actionType !== 'selectedProjectAddressCallBack'
        && actionType !== 'selededAdditional' && actionType !== 'uploadFile') {
            this.contractNumber = this.contractNumber || this.$route.params.contractNumber;
            this.getRetailDetailCopyNew(this.contractNumber);
            this.formData.register_time = util.currentTimeFormat('yyyy-MM-dd HH:mm:ss');
            this.getBusinessInstance();
        }
        this.$forceUpdate();
    },
    mounted() {},
    methods: {
        // 键盘输入
        keyBoardInput(value) {
            this.formData.pump_supplement_price = this.keyboardValue + value;
            this.$forceUpdate();
        },
        // 键盘删除
        keyBoardDel() {
            if (this.keyboardValue.length > 0) {
                this.keyboardValue = this.keyboardValue.substr(0, this.keyboardValue.length - 1);
            }
            this.formData.pump_supplement_price = this.keyboardValue;
            this.$forceUpdate();
        },
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'retailAccountList' });
            this.$router.go(-1);
        },
        // 定位界面
        toAddress() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'projectAddress',
                params: {
                    formData: this.formData,
                    from: 'newRetailAccount',
                    headerTitle: '工程地址',
                },
            });
        },
        // 跳转到上传附件界面
        toUpload() {
            if (this.formKeyValue) {
                let BusinessInstanceId = '';
                if (this.type === 'new') {
                    BusinessInstanceId = this.businessInfo.BusinessInstanceId;
                } else {
                    BusinessInstanceId = this.formData.business_instance_id;
                }
                this.$router.isBack = 2;
                this.$router.push(
                    {
                        name: 'fileUpload',
                        params: {
                            formData: this.formData,
                            BusinessInstanceId: BusinessInstanceId,
                            type: this.type,
                            fromPath: 'newRetailAccount',
                            title: '附件上传',
                        },
                    });
            } else {
                this.$toast('请先保存表单！');
            }

        },
        // 保存
        async handleSave(callBackFn) {
            const patrn = /^(-?\d+)(\.\d+)?$/;
            if (this.formData.price) {
                if (!patrn.test(Number(this.formData.price))) {
                    this.$toast('单价，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            if (this.formData.projected_capacity) {
                if (!patrn.test(Number(this.formData.projected_capacity ))) {
                    this.$toast('方量，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            if (this.formData.amount_money) {
                if (!patrn.test(Number(this.formData.amount_money))) {
                    this.$toast('金额，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            if (this.formData.haul_distance) {
                if (!patrn.test(Number(this.formData.haul_distance ))) {
                    this.$toast('运距，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            if (this.formData.freight) {
                if (!patrn.test(Number(this.formData.freight))) {
                    this.$toast('运费，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            const amount_money = this.formData.amount_money;
            const price = this.formData.price;
            const projected_capacity = this.formData.projected_capacity;
            let money = 0;
            if (price && projected_capacity) {
                money = Number(price) * Number(projected_capacity);
            }
            if (amount_money) {
                if (money > Number(amount_money) ) {
                    this.$toast('金额小于单价乘以方量，不能保存！');
                    return;
                }
            }
            this.showOverlay = true;
            if (this.type === 'new' || this.type === 'copyNew') {
                this.formData.business_instance_id = this.businessInfo.BusinessInstanceId;
                const res = await this.getAutoCode();
                if (res) {
                    this.formData.contract_number = res.AutoCodeValue;
                    this.formData.auto_index = `${res.AutoIndex}`;
                    this.$forceUpdate();
                    this.$axios
                        .post('/interfaceApi/sale/contract_manager/add_retail', this.formData)
                        .then(res => {
                            if (res) {
                                this.getRetailDetail(this.formData.contract_number);
                                this.startBusinessInstance(callBackFn);
                                this.formKeyValue = res;
                                this.type = 'modify';
                                this.$toast('保存成功！');
                            }
                        }).catch(error => {
                            this.showOverlay = false;
                            this.$toast({
                                type: 'html',
                                message: error.ErrorCode.Message,
                            });
                        });
                }
            } else {
                this.$axios
                    .put('/interfaceApi/sale/contract_manager/modify_retail', this.formData)
                    .then(res => {
                        if (res) {
                            this.$toast('修改成功！');
                            this.getCurrentProcess(callBackFn);
                            this.showOverlay = false;
                        }
                    }).catch(error => {
                        this.showOverlay = false;
                        this.$toast({
                            type: 'html',
                            message: error.ErrorCode.Message,
                        });
                    });
            }
        },
        // 启动流程实例
        startBusinessInstance(callBackFn) {
            this.showOverlay = true;
            const data = {
                BusinessInstanceId: this.businessInfo.BusinessInstanceId,
                ConfigBusinessId: this.businessInfo.ConfigBusiness.BusinessId,
                BusinessCode: this.businessInfo.ConfigBusiness.BusinessCode,
                BusinessName: this.businessInfo.ConfigBusiness.BusinessName,
            };
            this.$axios
                .post('/interfaceApi/basicplatform/simpleflow/businessinstance', data)
                .then(res => {
                    if (res) {
                        this.saveFrom(callBackFn);
                    }
                }).catch(error => {
                    this.$toast({
                        type: 'html',
                        message: error.ErrorCode.Message,
                    });
                });
        },
        // 记录保存过的表单数据
        saveFrom(callBackFn) {
            const data = {
                BusinessInstanceId: this.businessInfo.BusinessInstanceId,
                BusinessPhaseId: '',
                FormId: this.businessInfo.BusinessFormList[0].FormId,
                FormName: this.businessInfo.BusinessFormList[0].FormName,
                FormUrl: this.businessInfo.BusinessFormList[0].FormUrl,
                FormKeyName: this.businessInfo.BusinessFormList[0].FormKeyName,
                FormKeyValue: this.formKeyValue,
            };
            this.$axios
                .post('/interfaceApi/basicplatform/simpleflow/businessinstance/businessform', data)
                .then(() => {
                    this.getCurrentProcess(callBackFn);
                }).catch(error => {
                    this.$toast({
                        type: 'html',
                        message: error.ErrorCode.Message,
                    });
                });
        },
        // 根据环节获取流程实例信息
        getProcessData(callBackFn) {
            this.$axios
                .get('/interfaceApi/basicplatform/simpleflow/processes/'
                + this.approvalData.BusinessInstanceId + '/'
                + this.approvalData.BusinessProcessId)
                .then(res => {
                    // 流程数据
                    this.processData = res;
                    // 当前流程环节信息
                    this.CurrentBusinessProcess = res.CurrentBusinessProcess;
                    if (callBackFn) {
                        callBackFn();
                    }
                })
                .catch(error => {
                    this.showOverlay = false;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 提交
        handleSubmit() {
            if (JSON.stringify(this.CurrentBusinessProcess) === '{}') {
                this.handleSave(this.toSubmission);
            } else {
                this.toSubmission();
            }
        },
        // 跳转到提交界面
        async toSubmission() {
            this.showOverlay = false;
            // 获取环节数据请求
            // eslint-disable-next-line max-len
            const linkData = await this.getLinkDataRequest(this.approvalData.BusinessInstanceId, this.CurrentBusinessProcess.CurrentBusinessProcessId);

            let childrenData;
            // 判断环节提交模式和审批人类别，环节提交模式=1（默认环节），审批人类别=2（角色），打开选择人员弹出层
            if (
                linkData.PhaseSubmitMode === 1
                && linkData.SubmitPhaseModel
                && linkData.SubmitPhaseModel?.ApproverType === 2
                && linkData.SubmitPhaseModel?.IsAllowEditApprover
            ) {
                this.approverRoleId = linkData.SubmitPhaseModel.ApproverRoleId.split(',');
                this.approverRoleName = linkData.SubmitPhaseModel.ApproverRoleName.split(',');
                childrenData = {
                    title: '普通提交',
                    type: 'role',
                    approverRoleId: this.approverRoleId,
                    approverRoleName: this.approverRoleName,
                    processData: this.processData,
                };

                // 判断环节提交模式和审批人类别，环节提交模式=2或者=3（指定环节、自由环节）
            } else if ([2, 3].indexOf(linkData.PhaseSubmitMode) > -1) {
                this.businessPhaseId = linkData.BusinessPhaseId;
                childrenData = {
                    title: '自由提交',
                    type: 'link',
                    processData: this.processData,
                };
            } else {
                this.submitObj.link = linkData.SubmitPhaseModel?.BusinessPhaseName;
                this.submitObj.obj = linkData.SubmitPhaseModel?.ApproverName;
                this.confirmedByShow = true;
            }

            if (childrenData) {
                this.$router.isBack = 2;
                this.showOverlay = false;
                this.$router.push({
                    name: 'submission',
                    params: {
                        data: childrenData,
                        isNews: this.isNews,
                        backPathName: 'retailAccountList',
                    },
                });
            }
        },

        // 取消提交
        cancelSubmission() {
            this.$toast('已取消！');
        },

        // 确认提交
        confirmSubmission() {
            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 10,
            };
            this.submitAPI(data, '提交成功！', '/interfaceApi/basicplatform/simpleflow/processes');
        },

        // 流程提交请求
        submitAPI(data, message, url) {
            this.isloading = true;
            this.$axios
                .post(url, data)
                .then(() => {
                    this.$toast.success(message);
                    this.isReadOnly = true;
                    this.isloading = false;
                    if (this.isNews !== true) {
                        this.$router.isBack = 1;
                        this.$router.replace({
                            name: 'retailAccount',
                            params: {
                                isRefresh: true,
                            },
                        });
                        this.$router.go(-1);
                    }
                })
                .catch(error => {
                    this.isloading = false;
                    this.$toast({
                        type: 'html',
                        message: error.ErrorCode.Message,
                    });
                });
        },

        // 获取流程模板信息
        getBusinessInstance() {
            this.$axios
                .get('/interfaceApi/basicplatform/simpleflow/businessinstance/templateinfo/HTPS-LS2')
                .then(res => {
                    if (res) {
                        this.businessInfo = res;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取当前流程环节
        getCurrentProcess(callBackFn) {
            this.$axios.get('/interfaceApi/basicplatform/simpleflow/processes/transaction_model/' + this.formData.business_instance_id)
                .then(res => {
                    if (res) {
                        this.approvalData = res;
                        this.getProcessData(callBackFn);
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 初始化订单编号
        getAutoCode() {
            return this.$axios.$get('/interfaceApi/basicplatform/autocode/runtime?code=lsh_contract_code');
        },
        // 获取零售业务台账明细
        getRetailDetail(contractNumber) {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_retail_detail/' + contractNumber)
                .then(res => {
                    if (res) {
                        // res.price = res.price + '';
                        // res.projected_capacity = res.projected_capacity + '';
                        // res.amount_money = res.amount_money + '';
                        // res.haul_distance = res.haul_distance + '';
                        // res.freight = res.freight + '';
                        this.formData = res;
                        this.showOverlay = false;
                        this.formKeyValue = res.ciid;
                        const value = res.pouring_way_name;
                        if (value === '汽车泵' || value === '车载泵' || value === '固定泵') {
                            this.volumePriceDisable = false;
                        } else {
                            this.pump_supplement_price = 0;
                            this.volumePriceDisable = true;
                        }
                        if (value === '汽车泵') {
                            this.pumpTruckTypeDisable = true;
                            this.formData.pump_truck_name = '';
                            this.formData.pump_truck = '';
                        } else {
                            this.pumpTruckTypeDisable = false;
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取零售业务台账明细
        getRetailDetailCopyNew(contractNumber) {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_retail_detail/' + contractNumber)
                .then(res => {
                    if (res) {
                        this.formData.engineering_name = res.engineering_name;
                        this.formData.engineering_type = res.engineering_type;
                        this.formData.engineering_type_name = res.engineering_type_name;
                        this.formData.section = res.section;
                        this.formData.engineering_location = res.engineering_location;
                        this.formData.x_coordinate_point = `${res.x_coordinate_point}`;
                        this.formData.y_coordinate_point = `${res.y_coordinate_point}`;
                        this.formData.client_name = res.client_name;
                        this.formData.client_type = res.client_type;
                        this.formData.client_type_name = res.client_type_name;
                        this.formData.client_uscc = res.client_uscc;
                        this.formData.client_contact_id = res.client_contact_id;
                        this.formData.client_contact_name = res.client_contact_name;
                        this.formData.client_contact_phone = res.client_contact_phone;
                        this.formData.salesman_id = res.salesman_id;
                        this.formData.salesman_name = res.salesman_name;
                        this.formData.salesman_phone = res.salesman_phone;
                        this.formData.supply_site = res.supply_site;
                        this.formData.supply_site_name = res.supply_site_name;
                        this.formData.area_id = res.area_id;
                        this.formData.area_name = res.area_name;
                        this.formData.haul_distance = res.haul_distance + '';
                        this.showOverlay = false;
                        const value = res.pouring_way_name;
                        if (value === '汽车泵' || value === '车载泵' || value === '固定泵') {
                            this.volumePriceDisable = false;
                        } else {
                            this.pump_supplement_price = 0;
                            this.volumePriceDisable = true;
                        }
                        this.$forceUpdate();
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 展示日历
        handleShowCalendar(type) {
            this.calendarType = type;
            this.showCalendar = true;
        },
        // 登记时间-确认选择
        confirmMonth(value) {
            if (this.calendarType === 'register_time') {
                this.formData.register_time = this.formatDate(value);
            } else {
                this.formData.used_materials_time = this.formatDate(value);
            }
            this.showCalendar = false;
        },
        // 返回的时间格式化
        formatDate(date) {
            let month = date.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }
            let day = date.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            let Hours = date.getHours();
            if (Hours < 10) {
                Hours = '0' + Hours;
            }
            let Minutes = date.getMinutes();
            if (Minutes < 10) {
                Minutes = '0' + Minutes;
            }
            let Seconds = date.getSeconds();
            if (Seconds < 10) {
                Seconds = '0' + Seconds;
            }
            return `${date.getFullYear()}-${month}-${day} ${Hours}:${Minutes}:${Seconds}`;
        },
        // 展示下拉选择
        showPopup(type) {
            this.actionType = type;
            switch (type) {
                // 工程类型
                case 'engineering_type':
                    if (this.engineeringTypeColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.engineeringTypeColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 客户类型
                case 'client_type':
                    if (this.clientTypeColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.clientTypeColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 支付方式
                case 'payment_mode':
                    if (this.payModeColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.payModeColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 供货站点
                case 'supply_site':
                    if (this.supplySiteColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.supplySiteColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 销售区域
                case 'area_name':
                    if (this.saleAreaColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.saleAreaColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 强度等级
                case 'strength_grade':
                    if (this.strengthGradeColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.strengthGradeColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 浇筑部位
                case 'casting_parts':
                    if (this.castingPartsColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.castingPartsColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 浇筑方式
                case 'pouring_way':
                    if (this.pouringWayColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.pouringWayColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 泵车类型
                case 'pump_truck':
                    if (this.pouringTruckColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.pouringTruckColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                default:
                    // 默认代码块;
            }
        },
        // 下拉确认选择
        selectConfirm(data) {
            let obj = [];
            switch (this.actionType) {
                // 工程类型
                case 'engineering_type':
                    this.formData.engineering_type_name = data.name;
                    obj = this.engineeringTypeOriginal.filter(item => item.name === data.name);
                    this.formData.engineering_type = obj[0].code;
                    this.showActionSheet = false;
                    break;
                // 客户类型
                case 'client_type':
                    this.formData.client_type_name = data.name;
                    obj = this.clientTypeOriginal.filter(item => item.name === data.name);
                    this.formData.client_type = obj[0].code;
                    this.showActionSheet = false;
                    break;
                // 支付方式
                case 'payment_mode':
                    this.formData.payment_mode_name = data.name;
                    obj = this.payModeOriginal.filter(item => item.name === data.name);
                    this.formData.payment_mode = obj[0].code;
                    this.showActionSheet = false;
                    break;
                // 供货站点
                case 'supply_site':
                    this.formData.supply_site_name = data.name;
                    obj = this.supplySiteOriginal.filter(item => item.name === data.name);
                    this.formData.supply_site = obj[0].station_id;
                    this.showActionSheet = false;
                    break;
                // 销售区域
                case 'area_name':
                    this.formData.area_name = data.name;
                    obj = this.saleAreaOriginal.filter(item => item.name === data.name);
                    this.formData.area_id = obj[0].id;
                    this.showActionSheet = false;
                    break;
                // 强度等级
                case 'strength_grade':
                    this.formData.strength_grade_name = data.name;
                    obj = this.strengthGradeOriginal.filter(item => item.name === data.name);
                    this.formData.strength_grade = obj[0].code;
                    this.showActionSheet = false;
                    break;
                // 浇筑部位
                case 'casting_parts':
                    this.formData.casting_parts_name = data.name;
                    obj = this.castingPartsOriginal.filter(item => item.name === data.name);
                    this.formData.casting_parts = obj[0].code;
                    this.showActionSheet = false;
                    break;
                // 浇筑方式
                case 'pouring_way':
                    this.formData.pouring_way_name = data.name;
                    obj = this.pouringWayOriginal.filter(item => item.name === data.name);
                    this.formData.pouring_way = obj[0].code;
                    this.showActionSheet = false;
                    if (data.name === '汽车泵' || data.name === '车载泵' || data.name === '固定泵') {
                        this.volumePriceDisable = false;
                    } else {
                        this.volumePriceDisable = true;
                        this.pump_supplement_price = 0;
                    }
                    if (data.name === '汽车泵') {
                        this.pumpTruckTypeDisable = true;
                        this.formData.pump_truck_name = '';
                        this.formData.pump_truck = '';
                    } else {
                        this.pumpTruckTypeDisable = false;
                    }
                    break;
                // 泵车类型
                case 'pump_truck':
                    this.formData.pump_truck_name = data.name;
                    obj = this.pouringTruckOriginal.filter(item => item.name === data.name);
                    this.formData.pump_truck = obj[0].code;
                    this.showActionSheet = false;
                    break;
                default:
                    // 默认代码块;
            }

        },
        // 获取下拉框数据列表
        getCategory(parentCode, type) {
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=' + parentCode)
                .then(res => {
                    if (res) {
                        if (type === 'engineering_type') { // 工程类型
                            this.engineeringTypeOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.engineeringTypeColumns = arr;
                        } else if (type === 'client_type') {
                            this.clientTypeOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.clientTypeColumns = arr;
                        } else if (type === 'payment_mode') {
                            this.payModeOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.payModeColumns = arr;
                        } else if (type === 'casting_parts') {
                            this.castingPartsOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.castingPartsColumns = arr;
                        } else if (type === 'pouring_way') {
                            this.pouringWayOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.pouringWayColumns = arr;
                        } else if (type === 'pump_truck') {
                            this.pouringTruckOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.pouringTruckColumns = arr;
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取供货站点下拉list
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.supplySiteOriginal = stationList;
                this.supplySiteColumns = this.supplySiteOriginal.map(item => {
                    return { name: item.name };
                });
            }
        },
        // 获取销售区域下拉list
        getSaleAreaList() {
            this.$axios
                .get('/interfaceApi/sale/price_config/get_area_list')
                .then(res => {
                    if (res) {
                        this.saleAreaOriginal = res;
                        const arr = [];
                        res.map(item => {
                            arr.push({ name: item.name });
                        });
                        this.saleAreaColumns = arr;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取强度等级
        getStrengthGrade() {
            this.strengthGradeOriginal = [];
            this.strengthGradeColumns = [];
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist_recursion?parent_code=004')
                .then(res => {
                    if (res) {
                        for (let i = res.length - 1; i >= 0; i--) {
                            if (res[i].level === 3) {
                                this.strengthGradeColumns.unshift({ name: res[i].name });
                                this.strengthGradeOriginal.unshift(res[i]);
                            }
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist_recursion?parent_code=005')
                .then(res => {
                    if (res) {
                        res.map(item => {
                            if (item.level === 3) {
                                this.strengthGradeColumns.push(item);
                                this.strengthGradeOriginal.push(item);
                            }
                        });
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 选择附加型号
        showRequireList() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'selectAdditionalModel', params: { formData: this.formData, handleType: this.type } });
        },
        // 选择业务员
        selectSalesMan() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'selectSalesman', params: { formData: this.formData, handleType: this.type } });
        },
        inputFocusout() {
            this.timer = setTimeout(() => {
                window.scrollTo(0, 0);
                // 间隔设为10，减少页面失去焦点定时器的突兀感，
            }, 10);
        },
        showSelectOrg() {
            this.$refs.selectOrg.show = true;
        },
        // 选择供方单位
        handleSelectOrg(item) {
            this.$set(this.formData, 'org_code', item.org_code);
            this.$set(this.formData, 'org_name', item.org_name);
        },

        // 客户名称建议列表数据
        async customerNameInput() {
            this.customerSelectionList = await this.getClients(this.formData.client_name);
            this.showCustomerSelection = true;
        },

        // 客户选择
        handleSelect(item) {
            this.formData.client_type = item.nature;
            this.formData.client_type_name = item.nature_name;
            this.formData.client_id = item.id;
            this.formData.client_name = item.name;
            this.formData.client_uscc = item.license_code;
            this.formData.client_contact_name = item.client_contact_name;
            this.formData.client_contact_phone = item.client_contact_phone;
        },

        // 拉取客户信息列表
        getClients(Keywords) {
            return this.$axios.$get(`/interfaceApi/sale/client_manager/get_clients?Keywords=${Keywords}`, { defEx: true });
        },

        // 获取环节数据请求
        getLinkDataRequest(businessInstanceId, businessPhaseId) {
            const path = `/interfaceApi/basicplatform/simpleflow/processes/getcurrentbusinessprocess/${businessInstanceId}/${businessPhaseId}`;
            return this.$axios.$get(path, { defEx: true });
        },
    },

};
</script>
<style lang="stylus">
.newRetailAccount
    height 100%
    position relative
    section
        position relative
        .slump
            display inline-block
            width 40%
            border none
            text-align center
        .van-icon
            .van-icon__image
                width 16rpx
                height 16rpx
                margin-top 3rpx
                margin-right 5rpx
        .van-collapse
            &:after
                display none
        .van-cell__title
            width 100rpx
            font-size 15rpx
            line-height 24rpx
            color #061F3E
            .iconfont
                font-size 18rpx
                margin-right 5rpx
        .van-collapse-item__content
            .van-cell__title
                font-size 15rpx
        .van-button
            vertical-align top
        .title
            font-size 17rpx
            color #3495FB
        .van-collapse-item__content
            padding 0
        .van-field__control,
        .van-cell__value
            &::placeholder
                color #D7D7D7 !important
        .textarea
            position relative
            &:before
                position absolute
                top 20rpx
                left 26rpx
            textarea
                text-indent 30rpx
                &.van-field__control
                    border 1px solid #D7D7D7
                    border-radius 4px
                    padding 10rpx
                    height 100rpx !important
                    &::-webkit-input-placeholder
                        font-size 16rpx
        .textarea-parts
            width 100%
            .van-field__control
                border 1px solid #D7D7D7
                border-radius 4px
                padding 6rpx 10rpx
                height 60rpx !important
                font-size 14rpx
                &::-webkit-input-placeholder
                    font-size 16rpx
        .custom-field
            .van-field__control
                input
                    border none
                    margin-right 5rpx
                    &::webkit-input-placeholder
                        color #ddd
        .trans-types
            .van-field__control--custom
                display block
                .van-radio-group
                    margin-bottom 10rpx
            .custom-row
                margin-bottom 10rpx
                input
                    width 50rpx
                    border 0
                    border-bottom 1px solid #ccc
                    margin 0 10rpx
                    height 20rpx
                    text-align center
        .star
            .van-cell__title
                &:after
                    content '*'
                    color #E60000
        .submitPopUp
            .van-dialog__header
                padding-top 0
                line-height 50rpx
            .van-dialog__content
                padding 15rpx 0
                border-top 2px solid #F0F0F0
                text-align center
                .icon, .info
                    display inline-block
                    vertical-align top
                .icon
                    width 94rpx
                    height 84rpx
                    img
                        height 100%
                .info
                    text-align left
                    margin-top 10rpx
                    h4
                        line-height 20rpx
                        font-size 14rpx
                        color #666666
                        margin-bottom 20rpx
                        span
                            font-size 18rpx
                            color #3495FB
                    p
                        font-size 14rpx
                        color #979EA7
                    &.linkInfo
                        margin-top 5rpx
                        h4
                            margin-bottom 10rpx
        .customerSelection
            background #fff
            box-shadow 0 8px 12px rgb(100 101 102 / 12%)
            position fixed
            width 100%
            top 100px
            left 0
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
</style>
